export enum EditCompanyPanelEvents {
  AuthenticationTabOperationInProgress = 'companyAuthenticationTabOperationInProgress',
  LicensingTabOperationInProgress = 'companyLicensingTabOperationInProgress',
}
